import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { apiPath, baseUrl } from 'config'

import { UsersWithBalanceResponse } from 'store/reducers-admin/Users/type.ts'
import { getSignature } from 'utils/getSignature'

export const queryAdminUsers = createApi({
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getAllUsers: builder.query<UsersWithBalanceResponse, { limit: number; page: number }>({
      providesTags: ['AllUsers'],
      queryFn: async (arg, _api, _extraOptions, baseQuery) => {
        const url = `${apiPath.allUsers}?limit=${arg.limit}&page=${arg.page}`

        const { deadline, signature } = await getSignature({
          primaryType: 'GetAllUsers',
          url,
        })

        if (!signature) {
          return { error: new Error('No signature') as unknown as FetchBaseQueryError }
        }

        const result = await baseQuery({
          headers: { deadline: `${deadline}`, signature },
          url,
        })

        if (!result.data) {
          return { error: result.error as FetchBaseQueryError }
        }

        return { data: result.data as UsersWithBalanceResponse }
      },
    }),
  }),
  reducerPath: 'allUsers',
  tagTypes: ['AllUsers'],
})

export const { useGetAllUsersQuery } = queryAdminUsers
